import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const PageTitle = ({ title, children }) => {
  return (
    <Helmet
      defaultTitle="CompanyCam"
      titleTemplate="%s - CompanyCam"
      title={title}
    >
      {children}
    </Helmet>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default PageTitle;
